module.exports = __webpack_public_path__ + "static/media/dhlicon.ce777ce3.svg";